import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ReactSwipe from 'react-swipe';

import { makeSequence } from 'dpl/shared/utils';

export function MobileTipsSliderItem({ children }) {
  return (
    <div className="MobileTipsSliderItem h-100 pb2 ph2 relative dib v-mid">
      <div className="w-100 center">
        <div className="MobileTipsSliderItem__card ph4 pv4 br1 shadow-1">
          {children}
        </div>
      </div>
    </div>
  );
}

MobileTipsSliderItem.propTypes = {
  children: PropTypes.node.isRequired
};

export default function MobileTipsSlider({ className, tips }) {
  const [currentIdx, setCurrentIdx] = useState(0);

  function handleTransitionEnd(idx) {
    return setCurrentIdx(idx);
  }

  return (
    <div className={classnames('MobileTipsSlider', className)}>
      <div className="mb2">
        <ReactSwipe
          childCount={3}
          swipeOptions={{
            continuous: true,
            transitionEnd: handleTransitionEnd,
            widthOfSiblingSlidePreview: 16 // 16 + ph2 = 24
          }}
        >
          {tips.map((t, idx) => (
            <MobileTipsSliderItem key={idx}>{t}</MobileTipsSliderItem>
          ))}
        </ReactSwipe>
      </div>
      <div className="tc">
        {makeSequence(3).map(idx => (
          <span
            className={classnames(
              'MobileTipsSlider__dot pt1 pl1 mh2 dib br1 bg-black',
              { 'o-30': idx !== currentIdx }
            )}
            key={idx}
          />
        ))}
      </div>
    </div>
  );
}

MobileTipsSlider.propTypes = {
  tips: PropTypes.node.isRequired,
  className: PropTypes.string
};

MobileTipsSlider.defaultProps = {
  className: null
};
